module.exports = __webpack_public_path__ + "img/disconnect.fd6dec8f.png";